const getToggledClassName = isToggled => {
  return isToggled ? '!text-primary' : '!text-common-bright ';
};

export { getToggledClassName };
